import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loyalty-badge',
  templateUrl: './loyalty-badge.component.html',
  styleUrls: ['./loyalty-badge.component.sass']
})
export class LoyaltyBadgenComponent implements OnInit {
  @Input() count = '';
  @Input() total = '';

  constructor() { }

  ngOnInit() {
  }
}
